module.exports = __webpack_public_path__ + "static/img/server3.830cf03.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/server3.jpeg
// module id = xysX
// module chunks = 1